<template>
    <div v-show="show===true" class="delete-box-modal-overlay">
        <div class="delete-box deleteBox pc">
            <p class="delete-box__copy">{{message}}</p>
            <p class="delete-box__desc">{{subMessage}}</p>
            <div class="delete-box__btnwrap">
                <button class="cancel-btn" @click="hiddenConfirm(); cancel()">{{canselButtonName}}</button>
                <button class="delete-btn confirmBtn confirmDeleteBtn" @click="execution()">{{executionButtonName}}</button>
            </div>
        </div>
    </div>
</template>

<script>
import componentModalCenter from '../../js/modules/componentModalCenter.js'
import componentScrollControl from '../../js/modules/componentScrollControl.js'// eslint-disable-line

export default {
    name: 'Confirm',
    data() {
        return {
            show: false,
        }
    },
    props:{
        message: {
            type: String
        },
        subMessage: {
            type: String
        },
        canselButtonName: {
            type: String
        },
        executionButtonName: {
            type: String
        },
    },
    methods: {
        showConfirm() {// eslint-disable-line
            if (this.show === false) {
                this.show = true;
                this.$nextTick(function () {
                    componentScrollControl.no_scroll();
                    componentModalCenter(".delete-box");
                    document.getElementById('page_top').style.display = 'none';
                })
            }
        },
        hiddenConfirm() {
            componentScrollControl.return_scroll();
            this.show = false;
            this.$nextTick(function () {
                document.getElementById('page_top').style.display = '';
            })
        },
        cancel() {
            this.$emit('cancel');
        },
        execution() {
            this.$emit('execution');
        },
    },
}
</script>

<style lang="scss" scoped>
@import "../../assets/css/modal/Confirm.css";
</style>